import TeamzIcon from "@/assets/teamz.svg";
import { ArrowLeftCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  const { t } = useTranslation(["common"]);
  const navigate = useNavigate();

  return (
    <div className="flex h-full items-center justify-center px-4">
      <div className="flex w-full max-w-lg flex-col items-center gap-6 rounded-xl bg-white p-8 shadow-md">
        <TeamzIcon className="size-16" />

        <div>
          <h1 className="mb-2 text-balance text-center text-xl font-bold">
            {t("common:not-found") }
          </h1>
          <h2 className="mb-4 text-balance text-center font-medium">
            {t("common:not-found-msg")}
          </h2>
        </div>

        <Button
          variant="outline"
          onClick={() => navigate(-1)}
          className="w-full"
        >
          <ArrowLeftCircle />
          {t("common:back")}
        </Button>
      </div>
    </div>
  );
}
